"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TestBackend = _interopRequireDefault(require("../../../DragDropContextProvider/TestBackend"));
var _DragDropContextProvider = _interopRequireDefault(require("../../../DragDropContextProvider"));
var _jsxFileName = "/home/builduser/work/b60d7defec63c7cc/packages/wix-style-react/dist/cjs/DragAndDrop/Draggable/components/DraggableManager.js";
// Apply TestBackend for drag and drop on test environment
var isTestEnv = process.env.NODE_ENV === 'test';
class DraggableManager extends _react.default.Component {
  render() {
    var {
      dataHook,
      children
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-hook": dataHook,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20,
        columnNumber: 7
      }
    }, /*#__PURE__*/_react.default.createElement(_DragDropContextProvider.default, {
      backend: isTestEnv ? _TestBackend.default : undefined,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 9
      }
    }, children));
  }
}
DraggableManager.propTypes = {
  children: _propTypes.default.node,
  dataHook: _propTypes.default.string
};
var _default = exports.default = DraggableManager;
//# sourceMappingURL=DraggableManager.js.map